type IconName =
  | 'home'
  | 'tree'
  | 'chat'
  | 'book'
  | 'calendar'
  | 'bell'
  | 'user'
  | 'plus'
  | 'back'
  | 'search'
  | 'send'
  | 'offline'
  | 'refresh'
  | 'cake'
  | 'map'
  | 'trash'
  | 'eye'
  | 'edit'
  | 'arrow-right'
  | 'sun'
  | 'moon'
  | 'sparkles'
  | 'paperclip'
  | 'camera'
  | 'mic';

const paths: Record<IconName, string> = {
  home: 'M3 10.5 12 3l9 7.5M5 9.5V21h5v-6h4v6h5V9.5',
  tree: 'M12 3v6m0 0-5 3m5-3 5 3M7 12v3m10-3v3M4 15h6v5H4zm10 0h6v5h-6zM9 3h6v6H9z',
  chat: 'M4 5h16v11H8l-4 4V5z',
  book: 'M5 4h14v16H5zM8 8h8M8 12h8M8 16h5',
  calendar: 'M4 6h16v14H4zM8 3v5m8-5v5M4 10h16',
  bell: 'M6 9a6 6 0 1 1 12 0c0 5 2 6 2 6H4s2-1 2-6Zm4 9a2 2 0 0 0 4 0',
  user: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-8 9a8 8 0 0 1 16 0',
  plus: 'M12 5v14M5 12h14',
  back: 'M15 5l-7 7 7 7',
  search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm10 2-4.35-4.35',
  send: 'M3 11.5 21 3l-6 18-3.5-7L3 11.5Z',
  offline: 'M3 3l18 18M8.5 8.5A6 6 0 0 1 18 15M5 12a9 9 0 0 1 2-3M2 9a13 13 0 0 1 3-2',
  refresh: 'M20 11a8 8 0 1 0-2.3 6.7M20 5v6h-6',
  cake: 'M4 21h16M6 21v-7h12v7M6 14c1.5-2 3-2 4.5 0s3 2 4.5 0 3-2 3 0M12 3v4M9 5h6',
  map: 'M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3V6zM9 3v15m6-12v15',
  trash: 'M4 7h16M9 7V4h6v3m-8 0 1 14h8l1-14M10 11v6m4-6v6',
  eye: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Zm10 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  edit: 'M4 20h4L19 9l-4-4L4 16v4Zm9-13 4 4',
  'arrow-right': 'M5 12h14m-6-6 6 6-6 6',
  sun: 'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM12 1v3M12 20v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M1 12h3M20 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1',
  moon: 'M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z',
  sparkles: 'M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5L12 3Zm6 9 .9 2.6 2.6.9-2.6.9L18 19l-.9-2.6-2.6-.9 2.6-.9L18 12ZM5 14l.8 2.2L8 17l-2.2.8L5 20l-.8-2.2L2 17l2.2-.8L5 14Z',
  paperclip: 'M21 11.5 12.5 20a5 5 0 0 1-7-7L14 4.5a3.5 3.5 0 0 1 5 5L10.5 18a2 2 0 0 1-3-3L15.5 7',
  camera: 'M4 8h3l2-3h6l2 3h3v11H4V8Zm8 8a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z',
  mic: 'M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3zM5 11a7 7 0 0 0 14 0M12 18v3',
};

export function Icon({
  name,
  className = 'h-5 w-5',
}: {
  name: IconName;
  className?: string;
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d={paths[name]} />
    </svg>
  );
}
